<template>
  <div class="startpage">
    <div
      v-if="data"
      class="hidden debug-config"
    >
      {{ data }}
    </div>
    <div
      class="startpage-frame"
    >
      <StartpageSkeletonDefault />
    </div>
  </div>
</template>
<script setup lang="ts">
interface StartpageConfig {
  layout: 'Simple' | 'Compact' | 'Balanced';
}
const storeslug = useRoute()?.params?.storeslug;
const storeId = await getStoreIdBySlug(storeslug);
const storeCookie = useStoreCookie();
const { data } = await useFetch<StartpageConfig>((import.meta.client ? useRuntimeConfig()?.public?.apiUrl : '') + '/api/nea/startpage-service', {
  // The request URL can differ between server and browser; the payload key must not.
  key: `startpage:${storeId}`,
  baseURL: useRuntimeConfig().public.localDevelopment ? 'https://staging.brntgs.expert.de' : undefined,
  params: {
    store: storeId,
  },
});

if (storeId && storeId != storeCookie?.value) {
  storeCookie.value = storeId;
}
provide('startpageConfig', data);
useHead({
  title: 'Elektromarkt in Ihrer Nähe mit Online-Shop',
  meta: [
    {
      name: 'description',
      content:
        'Finden Sie hier Ihren expert Elektrofachmarkt in Ihrer Nähe und viele Aktionsangebote ✔ günstig im expert Online-Shop. expert – Mit den besten Empfehlungen.',
    },
    { property: 'pagetype', content: 'Start' },
  ],
});
</script>
<style lang="postcss" scoped>
.startpage {
  @apply bg-secondary;
  min-height: 900px;
}
.startpage-frame {
  @apply lg:container mx-auto p-4 lg:px-0 lg:pb-20 pt-4 flex flex-col gap-14 max-w-full;
}
</style>
